import { Link } from 'react-router-dom';
import { contactInfo } from '@/mocks/site';

type ContributeCtaProps = {
  title?: string;
  desc?: string;
};

export default function ContributeCta({
  title = '你手里的一条线索，可能就是下一篇调查的起点',
  desc = '把你的亲历经过、可提供的材料说明发给我们。编辑部会逐条阅读，并在进入核实流程时主动联系你确认细节。',
}: ContributeCtaProps) {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="relative overflow-hidden rounded-lg border border-primary-200 bg-primary-50 px-6 py-10 md:px-12 md:py-14">
          <div className="absolute -right-16 -top-16 w-56 h-56 rounded-full bg-accent-200/40 blur-2xl" aria-hidden="true" />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8 flex flex-col gap-4">
              <span className="inline-flex w-fit items-center gap-2 text-xs font-label font-medium tracking-[0.2em] uppercase text-primary-700">
                <i className="ri-megaphone-line" aria-hidden="true" />
                线索征集
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">{title}</h2>
              <p className="text-sm md:text-base leading-relaxed text-foreground-700 max-w-2xl">{desc}</p>
            </div>
            <div className="lg:col-span-4 flex flex-col gap-3 lg:items-end">
              <Link
                to="/about#submit"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-label px-6 py-3.5 rounded-md transition-colors whitespace-nowrap"
              >
                <i className="ri-send-plane-fill" aria-hidden="true" />
                提交爆料线索
              </Link>
              <a
                href={`mailto:${contactInfo.email}`}
                className="inline-flex items-center justify-center gap-2 border border-primary-300 hover:bg-background-50 text-primary-700 font-label text-sm px-6 py-3 rounded-md transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line" aria-hidden="true" />
                {contactInfo.email}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}